import * as React from "react";
import { FormControl, Grid, InputLabel, OutlinedInput } from "@mui/material";
import { Controller } from "react-hook-form";

import { CustomFormHelperError } from "@/components/customFormHelper/custom-form-helper-error";
import { DynamicField } from "@/components/dynamicField/dynamic-field";
import { DynamicFieldType } from "@/components/dynamicField/types";

export function BasicInformation({
	control,
	flows,
	onFlowChange,
	isEdit,
	settings,
  hasInboundPrompt,
}: {
	control: any;
	flows: any;
	onFlowChange: any;
	isEdit: any;
	settings: any;
  hasInboundPrompt: boolean;
}) {
	return (
		<Grid container spacing={2}>
			<Grid
				size={{
					md: 12,
					xs: 12,
				}}
			>
				<Controller
					control={control}
					name="name"
					rules={{
						required: "Name is required",
						minLength: {
							value: 2,
							message: "Name must be at least 2 characters",
						},
					}}
					render={({ field, fieldState }) => (
						<FormControl error={Boolean(fieldState.error)} fullWidth required>
							<InputLabel>Name</InputLabel>
							<OutlinedInput {...field} placeholder="Enter name" />
							{fieldState.error && <CustomFormHelperError text={fieldState.error.message || ""} />}
						</FormControl>
					)}
				/>
			</Grid>

			<Grid
				size={{
					md: 12,
					xs: 12,
				}}
			>
				<DynamicField
					control={control}
					type={DynamicFieldType.SELECT}
					name="flow"
					label="Conversation Flow"
					disabled={isEdit}
					onChange={onFlowChange}
					dynamicField={{
						name: "flow",
						required: true,
						type: DynamicFieldType.SELECT,
						label: "Conversation Flow",
						placeholder: "Select a conversation flow",
						options: flows.map((flow: any) => ({ value: flow.name, label: flow.title })),
					}}
				/>
			</Grid>

			<Grid
				size={{
					md: 12,
					xs: 12,
				}}
			>
				<DynamicField
					control={control}
					type={DynamicFieldType.TEXT_AREA}
					name="prompt"
					label="Prompt"
					dynamicField={{
						name: "prompt",
						required: true,
						type: DynamicFieldType.TEXT_AREA,
						label: "Prompt",
						placeholder: "Enter prompt",
						multiline: true,
            withCustomFields: true,
					}}
				/>
			</Grid>

      <Grid size={{ md: 12, xs: 12 }}>
				<DynamicField
					control={control}
					type={DynamicFieldType.CHECKBOX}
					name="hasInboundPrompt"
					label="Enable separated prompt for inbound calls"
					dynamicField={{
						name: "hasInboundPrompt",
						type: DynamicFieldType.CHECKBOX,
						label: "Enabled",
					}}
				/>
			</Grid>
			{hasInboundPrompt && (
				<Grid size={{ md: 12, xs: 12 }}>
					<DynamicField
						control={control}
						type={DynamicFieldType.TEXT_AREA}
						name="inboundPrompt"
						label="Inbound Prompt"
						dynamicField={{
							name: "inboundPrompt",
							required: true,
							type: DynamicFieldType.TEXT_AREA,
							label: "Inbound Prompt",
							placeholder: "Enter inbound prompt",
							multiline: true,
							withCustomFields: true,
						}}
					/>
				</Grid>
			)}

      {settings.map((setting: any) => (
				<Grid
					key={setting.name}
					size={{
						md: 12,
						xs: 12,
					}}
				>
					<DynamicField
						control={control}
						type={setting.type}
						name={`settings.${setting.name}`}
						label={setting.label}
						dynamicField={setting}
						formName="settings"
					/>
				</Grid>
			))}
		</Grid>
	);
}
